import React from 'react';
import { MARQUEE } from '../data/mock';

export default function Marquee() {
  const items = [...MARQUEE, ...MARQUEE];
  return (
    <section className="relative bg-[#C8FF61] text-[#0A0B0E] py-6 md:py-8 overflow-hidden border-y border-[#C8FF61]">
      <div className="flex animate-marquee-fast whitespace-nowrap">
        {items.map((item, i) => (
          <div key={i} className="flex items-center gap-12 px-6">
            <span className="font-display-tight text-[28px] md:text-[44px] leading-none">{item}</span>
            <span className="font-serif-italic text-[28px] md:text-[44px] text-[#0A0B0E]/60">—</span>
          </div>
        ))}
      </div>
    </section>
  );
}
